module.exports = __webpack_public_path__ + "media/application/images/ui/icon-information-96ac3ba1207018cadedd5e3f35801027.png";